import { Link } from 'react-router-dom';
import { useAuth, useAuthStatus } from '../../contexts/AuthContext';
import { useBook } from '../../contexts/BookContext';
import styles from './HomePage.module.css';

const HomePage: React.FC = () => {
  const { user } = useAuth();
  const { isAuthenticated } = useAuthStatus();
  const { book, isLoading } = useBook();

  if (isLoading) {
    return (
      <div className={styles.homePage}>
        <div className={styles.container}>
          <div className={styles.loadingContainer}>
            <div className="spinner"></div>
            <p>Loading book content...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.homePage}>
      <div className={styles.heroSection}>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            <h1>Cybersecurity for Medical Devices: </h1>
            <p className={styles.heroSubtitle}>
              A Total Product Lifecycle Approach
            </p>
            
            {!isAuthenticated ? (
              <div className={styles.heroActions}>
                <p className={styles.previewText}>
                  Get a preview of the table of contents below. Create your free account to access the full book.
                </p>
                <div className={styles.actionButtons}>
                  <Link to="/register" className="btn btn-primary">
                    Get Full Access
                  </Link>
                  <Link to="/login" className="btn btn-outline">
                    Sign In
                  </Link>
                </div>
              </div>
            ) : (
              <div className={styles.heroActions}>
                <p className={styles.welcomeText}>
                  Welcome back, {user?.firstName}! Ready to continue reading?
                </p>
                <div className={styles.actionButtons}>
                  <Link to="/dashboard" className="btn btn-primary">
                    Continue Reading
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={styles.previewSection}>
        <div className={styles.container}>
          <h2>Table of Contents</h2>
          {book && (
            <div className={styles.tocPreview}>
              {book.chapters.map((chapter, _index) => (
                <div key={chapter.id} className={styles.chapterPreview}>
                  <h3 className={styles.chapterTitle}>
                    {chapter.title}
                  </h3>
                  <div className={styles.sectionsPreview}>
                    {chapter.sections.slice(0, 3).map((section) => (
                      <div key={section.id} className={styles.sectionPreview}>
                        <span className={styles.sectionTitle}>{section.title}</span>
                      </div>
                    ))}
                    {chapter.sections.length > 3 && (
                      <div className={`${styles.sectionPreview} ${styles.moreSections}`}>
                        <span className={styles.sectionTitle}>
                          ... and {chapter.sections.length - 3} more sections
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          
          {!isAuthenticated && (
            <div className={styles.accessPrompt}>
              <div className={styles.promptCard}>
                <h3>Want to read the full content?</h3>
                <p>
                  Create your free account to access the complete guide. You'll also receive our weekly cybersecurity newsletter and occasional webinar invites.
                </p>
                <div className={styles.promptActions}>
                  <Link to="/register" className="btn btn-primary">
                    Create Free Account
                  </Link>
                  <Link to="/login" className="btn btn-secondary">
                    Already have an account?
                  </Link>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HomePage;
